import download from 'downloadjs'
import request from '@/modules/base/util/request'

/**
 * download file
 * @param {string} url
 * @param {string?} filename
 * @param {string?} mimeType
 * @returns {Promise<XMLHttpRequest|boolean>}
 */
export const downloadFile = (url, filename, mimeType) => {
  return request(url, {
    responseType: 'arraybuffer',
    auth: true,
    isConcurrent: true,
  }).then((response) => {

    return download(response.body, filename ?? response.response.headers['filename'], mimeType ?? response.response.headers['content-type'])
  })
}
